<span
  class="d-flex align-items-center"
  [ngClass]="{'c-increase': change >= 0 , 'c-decrease': change < 0}">
  <span class="material-icons px-1">
    {{ change >= 0 ? 'north_east' : 'south_east' }}
  </span>
  {{ isNegative? (change || 0) : (- change || 0) }}%
</span>
